import { render, staticRenderFns } from "./CartPanel.vue?vue&type=template&id=a485c484&scoped=true&"
import script from "./CartPanel.vue?vue&type=script&lang=js&"
export * from "./CartPanel.vue?vue&type=script&lang=js&"
import style0 from "./CartPanel.vue?vue&type=style&index=0&id=a485c484&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a485c484",
  null
  
)

export default component.exports